import api from "../../../services/api";

const getMasterKaryawan = ({ commit }, params = {}) => {
  return new Promise((resolve, reject) => {
    api
      .get("/master/karyawan/paginate", {
        params
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESULTMASTERKARYAWAN", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getMasterCareerTransisition = ({ state, commit }, payload) => {
  return new Promise((resolve, reject) => {
    api
      .get("/career/history", {
        params: {
          id: payload,
          search: state.search,
          page: state.page
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_MASTER_CAREER_TRANSISITION", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getCompany = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/company").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_COMPANYLIST", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteJatahcuti = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/jatahcuti/" + state.idCuti).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteUser = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/karyawan/" + state.idDeleteUser).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const resetPassowd = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/reset/password/" + state.idDeleteUser).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterJatahcuti = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/jatahcuti/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTCUTI", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const searchKaryawan = ({ commit }, params = {}) => {
  return new Promise((resolve, reject) => {
    api.get("/master/karyawan/search", { params }).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTSEARCH", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertJatahCuti = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/jatahcuti/", state.tempJatahCuti).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateJatahCuti = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/jatahcuti/" + state.idCuti, state.tempJatahCuti).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterJatahcutiById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/jatahcuti/" + state.idCuti).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTEDITCUTI", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteJatahCuti = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/jatahcuti/" + state.idCuti).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterCost = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/cost/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTCOST", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterCostById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/cost/" + state.idcost).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTCOSTEDIT", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertCost = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/cost/", state.tempCost).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateCost = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/cost/" + state.idcost, state.tempCost).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteCost = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/cost/" + state.idcost).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterGrade = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/jobgrade/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMASTERGRADE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterGradeById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/jobgrade/" + state.idJobgrade).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTEDITJOB", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertJobGrade = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/jobgrade/", state.tempJobgrade).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateGrade = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/jobgrade/" + state.idJobgrade, state.tempJobgrade).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteGrade = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/jobgrade/" + state.idJobgrade).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterPosition = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/posisition/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMASTERPOSITION", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterPositionById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/posisition/" + state.idPosition).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTEDITPOSITION", res.data[0]);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertPosition = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/posisition/", state.tempPosition).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updatePosition = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/posisition/" + state.idPosition, state.tempPosition).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deletePosition = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/posisition/" + state.idPosition).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterRole = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/role/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTROLE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMenus = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/menus/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMENUS", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertRole = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/role/", state.tempROle).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterRoleByid = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/role/" + state.idROle).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTROLEEDIT", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateRole = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/role/" + state.idROle, state.tempROle).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getStore = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/store").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESSTORE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getDownloadKaryawan = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/download/karyawan").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESEXPORTKARYAWAN", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getDownloadKaryawanOnly = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/download/karyawan-only").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESEXPORTKARYAWAN", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterTax = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/tax").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMASTERTAX", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterTaxById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/tax/" + state.idTax).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTEDITTAX", res.data[0]);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertTax = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master/tax/", state.tempTax).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateTax = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master/tax/" + state.idTax, state.tempTax).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteTax = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/tax/" + state.idTax).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterDepartemen = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master_departemen").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMASTERDEPARTEMEN", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const insertDepartemen = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/master_departemen", state.tempDepartemen).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getMasterDepartemenById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/master_departemen/" + state.idDepartemen).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTEDITDEPARTEMEN", res.data[0]);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateDepartemen = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/master_departemen/" + state.idDepartemen, state.tempDepartemen).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const deleteDepartemen = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master_departemen/" + state.idDepartemen).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  updateRole,
  getMasterRoleByid,
  getStore,
  insertRole,
  getMenus,
  getMasterRole,
  deleteGrade,
  getMasterGradeById,
  updateGrade,
  insertJobGrade,
  getMasterGrade,
  deleteCost,
  updateCost,
  getMasterCostById,
  insertCost,
  getMasterCost,
  deleteJatahCuti,
  updateJatahCuti,
  getMasterKaryawan,
  deleteUser,
  getMasterJatahcuti,
  deleteJatahcuti,
  searchKaryawan,
  insertJatahCuti,
  getMasterJatahcutiById,
  getMasterPosition,
  getMasterPositionById,
  insertPosition,
  updatePosition,
  deletePosition,
  getMasterTax,
  getMasterTaxById,
  insertTax,
  updateTax,
  deleteTax,
  getDownloadKaryawan,
  resetPassowd,
  getDownloadKaryawanOnly,
  getCompany,
  getMasterCareerTransisition,
  getMasterDepartemen,
  getMasterDepartemenById,
  insertDepartemen,
  updateDepartemen,
  deleteDepartemen
};
